import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const JOBS_QUERY_KEY = ['jobs'];

/**
 * Shared hook to fetch job postings.
 * Ensures a single `/api/job-posts/jobs` network call is reused
 * across any component that needs the jobs list.
 */
export function useJobs(enabled = true, includeExternal = false) {
  return useQuery({
    queryKey: ['jobs', { includeExternal }],
    queryFn: async () => {
      const response = await axios.get('/api/job-posts/jobs', {
        params: includeExternal ? { includeExternal: 'true' } : {},
      });
      if (response.data?.cached) {
        // eslint-disable-next-line no-console
        console.log('Jobs loaded from Redis cache');
      }
      return response.data?.jobs || [];
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled,
  });
}

